import md5 from 'blueimp-md5'
import { format, Base64 } from './index.js'
class EmapHelp {
  constructor(option = {}) {
    this.option = option
    this.init(option)
  }
  init({ device, user, run }) {
    this.sys = {
      devicetype: ['android', 'iPhone'].filter(item => {
        return navigator.userAgent.toUpperCase().includes(item.toUpperCase())
      })[0],
      ext3: device.system,
      isencrypt: 'true',
      ext2: device.model,
      keycode: process.env.VUE_APP_keycode,
      networktype: '',
      apiversion: 'v1',
      deviceid: device.deviceID,
      usertoken: user.userToken,
      ext1: user.userId,
      appcode: run.appCode
    }
  }
  generateEmapSn() {
    return `M002601${format(new Date(), 'yyyyMMddhhmmss')}${md5(
      this.option.device.deviceID
    )}${Math.random()
      .toString()
      .substr(-6, 6)}`
  }
  getParams({ method, reqdata }) {
    let { apicode, token } = JSON.parse(process.env[`VUE_APP_${method}`])
    this.sys.apicode = apicode
    this.sys.token = token
    this.sys.emapsn = this.generateEmapSn()
    return `xmas-json=${JSON.stringify({
      sys: { ...this.sys },
      biz: {
        reqdata: encodeURIComponent(
          Base64.encode(
            typeof reqdata === 'object' ? JSON.stringify(reqdata) : reqdata
          )
        )
      }
    })}`
  }
}

export default EmapHelp
